import { useEffect } from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { Navbar } from '@/components/layout/Navbar'
import { Footer } from '@/components/layout/Footer'
import { Home } from '@/components/pages/Home'
import { CommandPalette } from '@/components/ui/CommandPalette'
import { CursorSpotlight } from '@/components/ui/CursorSpotlight'
import { SailboatWithRipples } from '@/components/SailboatWithRipples'
import { ProjectDetail } from '@/components/pages/ProjectDetail'
import { initializeTheme } from '@/lib/theme'
import { useScrollToTop } from '@/hooks/useScrollToTop'

const commandPaletteCommands = [
  {
    id: 'about',
    title: 'About',
    description: 'Learn more about me',
    action: () => {
      document.getElementById('about')?.scrollIntoView({ behavior: 'smooth' })
    },
    keywords: ['about', 'bio', 'background']
  },
  {
    id: 'skills',
    title: 'Skills',
    description: 'View my technical skills',
    action: () => {
      document.getElementById('skills')?.scrollIntoView({ behavior: 'smooth' })
    },
    keywords: ['skills', 'expertise', 'technologies']
  },
  {
    id: 'projects',
    title: 'Projects',
    description: 'See my recent work',
    action: () => {
      document.getElementById('projects')?.scrollIntoView({ behavior: 'smooth' })
    },
    keywords: ['projects', 'work', 'portfolio']
  },
  {
    id: 'contact',
    title: 'Contact',
    description: 'Get in touch',
    action: () => {
      document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })
    },
    keywords: ['contact', 'email', 'reach out']
  },
  {
    id: 'github',
    title: 'GitHub',
    description: 'View my GitHub profile',
    action: () => {
      window.open('https://github.com', '_blank')
    },
    keywords: ['github', 'code', 'repository']
  },
  {
    id: 'linkedin',
    title: 'LinkedIn',
    description: 'Connect on LinkedIn',
    action: () => {
      window.open('https://linkedin.com', '_blank')
    },
    keywords: ['linkedin', 'professional', 'network']
  }
]

function AppContent() {
  // Scroll to top on route changes
  useScrollToTop()

  return (
    <div className="min-h-screen bg-bg-light dark:bg-bg-dark text-text-light dark:text-text-dark transition-colors duration-300">
      <SailboatWithRipples />
      
      <Navbar />
      
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/projects/:projectId" element={<ProjectDetail />} />
      </Routes>
      
      <Footer />
      
      <CommandPalette 
        commands={commandPaletteCommands}
      />
      
      <CursorSpotlight />
    </div>
  )
}

function App() {
  useEffect(() => {
    // Initialize theme
    const cleanup = initializeTheme()
    return cleanup
  }, [])

  return (
    <Router>
      <AppContent />
    </Router>
  )
}

export default App